import React, { FC } from 'react';
import { InfoView } from 'components/InfoView';
import { translationKeys, useTranslation } from 'services/localization';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import Moving from './moving.svg';

const styles = css({
  maxWidth: '400px',
  padding: token('space.200'),
});

const NotFoundView: FC = () => {
  const { translate } = useTranslation();
  return <InfoView title={translate(translationKeys.USER_NOT_FOUND_MESSAGE)} hero={<Moving css={styles} />} />;
};

export default NotFoundView;
